import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import HeroImage from '../components/HeroImage'
import Banner from '../components/Banner'
import InvestorForm from '../components/forms/InvestorForm'


const Investor = () => {
    return (
        <div>
            <Navbar />
            <HeroImage heading='Investors Entry' text='Please complete the registration form' />
            <InvestorForm />
            <Banner />
            <Footer />
        </div>
    )
}

export default Investor;
